<ng-container [ngSwitch]="view">
  <ng-container *ngSwitchCase="'not-found'">
    <ng-container *ngTemplateOutlet="notFoundRef"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'meeting'">
    <ng-container *ngTemplateOutlet="meetingRef"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'user-service'">
    <ng-container *ngTemplateOutlet="userServiceRef"></ng-container>
  </ng-container>
</ng-container>

<ng-template #meetingRef>
  <div class="meeting">
    <app-breadcrumbs></app-breadcrumbs>
    <app-meeting-card [meeting]="meeting"></app-meeting-card>

    <div class="qrcode-wrap" *ngIf="deviceService.isDesktop()">
      <qrcode
        *ngIf="isBrowser && joinMeetingUrl"
        [qrdata]="joinMeetingUrl"
        [width]="120"
        [errorCorrectionLevel]="'low'"
        [elementType]="'svg'"></qrcode>
      <div>
        <div class="note strong">{{ 'meetings.join.qr-code-note' | customLocale }}<!--Отсканируйте этот QR-код с ссылкой, чтобы заниматься в классе со смартфона или планшета--></div>
        <div class="link">{{ joinMeetingUrl }}</div>
      </div>
    </div>

    <ng-template [ngIf]="participants.loaded">
      <table class="participants">
        <thead>
        <tr>
          <th class="column-user">Участники</th>
          <th class="column-role">Статус</th>
          <th class="column-billing-status" *ngIf="isPaidMeeting && isAuthor">Оплата</th>
          <th class="column-amount" *ngIf="isPaidMeeting && isAuthor">Сумма</th>
        </tr>
        </thead>
        <tbody>
        <tr class="spacer"><td colspan="4"></td></tr>
        <ng-template ngFor let-participant [ngForOf]="participants.items" let-i="index" [ngForTrackBy]="trackParticipantByFn">
          <tr class="participant">
            <td class="column-user">
              <div class="user-avatar">
                <a [routerLink]="accountRoute(participant.user)" class="image image-circle image-avatar-small">
                  <img *ngIf="userpicUrl(participant.user)"
                       [src]="userpicUrl(participant.user)"
                       [attr.alt]="getUserName(participant.user)"
                       [attr.title]="getUserName(participant.user)">
                </a>
              </div>
              <div class="user-name">
                <a [routerLink]="accountRoute(participant.user)" class="participant-name">
                  {{ getUserName(participant.user) }}
                </a>
                <div (click)="writeTo(participant.user_id)" *ngIf="participant.user_id !== me.id">Написать</div>
              </div>
            </td>
            <td class="column-role">{{ roleName(participant.role) | customLocale }}</td>
            <td class="column-billing-status" *ngIf="isPaidMeeting && isAuthor">{{ billingStatus(participant.billing_status) | customLocale }}</td>
            <td class="column-amount" *ngIf="isPaidMeeting && isAuthor"> --- </td>
          </tr>
        </ng-template>
        <tr class="spacer"><td colspan="4"></td></tr>

        <ng-template [ngIf]="isPaidMeeting && isAuthor">
          <tr class="summary">
            <td>.</td>
            <td>..</td>
            <td>...</td>
            <td>....</td>
          </tr>
        </ng-template>
        </tbody>
      </table>
    </ng-template>

    <app-pagination
      [enabled]="participants.loaded"
      [loading]="participants.loading"
      [pagination]="participants.pagination"
      baseUrl=""
      (nextPage)="nextParticipantsPage()"></app-pagination>
  </div>
</ng-template>

<ng-template #userServiceRef>
  <div class="user-service" [class.mobile]="deviceService.isMobile()">
    <app-user-service-card-full [userService]="userService"></app-user-service-card-full>
  </div>

  <router-outlet></router-outlet>
</ng-template>

<ng-template #notFoundRef>
  <app-content-not-found [title]="'meetings.meeting-not-found'"></app-content-not-found>
</ng-template>
